export default "__VITE_ASSET__DAshSRdJ__"